import React from "react";
import Divider from "./divider";
import BackButton from "./back_button";
import { classNames, If } from "react-extras";
import { Grid, Row, Col } from "react-bootstrap";
import Spinner from "./spinner";
const PageWrapper = ({
  noDivider,
  children,
  title,
  backLink,
  className,
  backText,
  topRightElement,
  dividerMarginBottom,
  noMaxWidth,
  afterTitleElement,
  isLoading,
  topOfPage,
  EyeBrow,
}) => {
  return (
    <div className={classNames(className, "page-wrapper", noMaxWidth && "no-max-width")}>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            {!!topOfPage && topOfPage}
            <div style={{ marginTop: backLink ? "30px" : "52px", marginBottom: 0 }}>
              {backLink && <BackButton to={backLink} text={backText} />}
              {!!EyeBrow && EyeBrow}
              <div className={"flex-row-container align-end"}>
                <h1 className={"m-a0"}>{title}</h1>
                <If condition={!!afterTitleElement}>
                  {!!afterTitleElement && afterTitleElement()}
                </If>
                <If condition={!!topRightElement}>
                  <>
                    <div className="flex-1" />
                    {!!topRightElement && topRightElement()}
                  </>
                </If>
              </div>
            </div>
            <If condition={!noDivider}>
              <Divider marginBottom={dividerMarginBottom} smallMargin />
            </If>
          </Col>
        </Row>
      </Grid>
      <If condition={!isLoading}>
        <>{children}</>
      </If>
      <Spinner isLoading={isLoading} />
    </div>
  );
};

export default PageWrapper;
